export default __webpack_public_path__ + "static/media/SJA1390.34I-42034_-25253_0.32d47e6c.jpg";